// ISO-639-1 Alpha-2 to assumed ISO-3116-1 Alpha-2
export default {
    en: 'GB',
    fr: 'FR',
    tr: 'TR',
};



// WEBPACK FOOTER //
// ./resources/assets/js/helpers/codes/translate.js